import {
    GetList,
    PostPartner,
    DeletePartner,
    GetPartner,
    PutPartner,
    ChangePartnerStatus,
} from '@src/services/partners'

export const state = {
    listPartners: [],
}

export const getters = {
    totalList(state) {
        return state.listPartners.data
            ? state.listPartners.data.totalItemCount
            : 0
    },
}

export const mutations = {
    FETCH_LIST(state, partners) {
        state.listPartners = partners
    },
    SET_STATE(state, payload) {
        if (state.listPartners.data) {
            state.listPartners.data.items.find(({ publicId }) => {
                return publicId === payload.publicId
            }).status = payload.status
        }
    },
    SET_STATE_FORM(state, payload) {
        state.partnersFormState = payload
    },
    UPDATE_PLAN(state, payload) {
        state.partnersFormState = payload
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.listPartners.data.items.push(team)
        })
    },
}

export const actions = {
    // retorna a lista de piscinas
    async fetchList({ commit }, parameters = {}) {
        // se a lista de partners estiver vazia, ela é preenchida com opções
        const resp = await GetList(parameters)

        if (resp && resp.status === 200) {
            commit('FETCH_LIST', resp.data)
        }
    },
    async getPartner({ _ }, parameters) {
        const resp = await GetPartner(parameters)
        return resp
    },
    async saveNewPartner({ _ }, parameters) {
        const resp = await PostPartner(parameters)
        return resp
    },
    async editPartner({ _ }, params) {
        const resp = await PutPartner(params)
        return resp
    },
    async delete({ dispatch }, data) {
        const resp = await DeletePartner(data)

        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async toggleStatus(_, data) {
        const resp = await ChangePartnerStatus(data)
        return resp
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
}
